import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step1: {
    name: "", //title
    country_id: "", //location
    city_id: null, //location
    product_type_id: 3, // Hotel
    address: "", //location
    phone: "", //location
    latitude: "",
    longitude: "",
    construction_year: "", //general info
    last_renovation_year: "", //general info
    number_of_rooms: 10, //general info
    number_of_swimmingpool: 0, //general info
    number_of_restaurant: 0, //general info
    number_of_floor: 1, //general info
    meal_age_autorizate: "", //general info
    checkin_time: "", //general info
    checkout_time: "", //general info
    pricing_type: "per_room", //general info
    short_summary: "", //description
    detailed_description: "", //description
  },

  step2: {
    is_has_reception: false, //reception
    reception: {
      //reception
      start_time: "",
      end_time: "",
      days: "",
    },

    is_has_reception_virtual: false, //reception
    is_will_welcome_travelers: false, //reception
    welcomProcedure: [], //reception

    is_early_arrival_available: false, //reception
    early_arrival: {
      //reception
      start_time: "",
      end_time: "",
      price: 0,
    },

    is_late_arrival_available: false, //reception
    late_arrival: {
      //reception
      start_time: "",
      end_time: "",
      price: 0,
    },

    min_check_in_age: null, //reception

    is_has_internet_connection: false, //equipments {
    internetService: [],

    is_parking_available: false,
    parkingService: [],

    is_swimming_pool_available: false,
    swimmingPoolService: [],

    is_accessibility_arrangement: false,
    accessibilityArrangement: [],

    is_general_services_available: false,
    generalService: [],

    is_room_amenities: false,
    roomAmenities: [],

    is_sports_attractions: false,
    sportAttractionService: [],

    is_wellness_services: false,
    wellnessService: [],

    is_business_services: false,
    businessService: [],

    is_family_romantic_services: false,
    familyRomantiqueService: [],

    is_nature_environment_services: false,
    natureEnvironment: [], // } equipments
  },

  step3: {
    rooms: [
      //rooming
      {
        room_type_id: null,
        room_option_id: null,
        bed_type_id: null,
        number_of_beds: 1,
        is_extra_beds_available: false,
        is_baby_beds_available: false,
        is_smoking_allowed: false,
        is_wheelchair_accessible: false,
        number_of_living_areas: 1,
        number_of_rooms: 1,
        total_rooms_of_this_type: 0,
        min_adults: 1,
        max_adults: 1,
        min_children: 0,
        max_children: 0,
        real_number_pax: 1,
        pricing: {
          start_date: "",
          end_date: "",
          price: "",
          mealId: null,
        },
      },
    ],
    charge_service: "5",
    charge_service_type: "out",
    meal_rate:[],
  },
};

// ============================
// Helper for nested updates
// ============================
function deepUpdate(obj, field, value) {
  if (obj && typeof obj === "object") {
    if (field in obj) {
      obj[field] = value;
      return true;
    }
    for (const key of Object.keys(obj)) {
      if (deepUpdate(obj[key], field, value)) {
        return true;
      }
    }
  }
  return false;
}

// ============================
// Slice definition
// ============================
const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    updateHotelStepField: (state, action) => {
      const { field, value } = action.payload;

      if (typeof field !== "string") {
        console.error("updateHotelStepField: invalid field", field);
        return;
      }

      // Dot notation support
      if (field.includes(".")) {
        const keys = field.split(".");
        let target = state;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!target[keys[i]]) return;
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
        return;
      }

      // Deep search fallback
      if (!deepUpdate(state, field, value)) {
        console.warn(`Field '${field}' not found in state`);
      }
    },

    updateHotelStepBulk: (state, action) => {
      const { step, data } = action.payload;
      state[step] = { ...state[step], ...data };
    },

    setHotelProductId: (state, action) => {
      state.product_id = action.payload;
      state.step2.product_id = action.payload;
      state.step3.product_id = action.payload;
    },

    // ============================
    // Generic Service Updaters
    // ============================
    updateHotelService: (state, action) => {
      const { serviceKey, id, value } = action.payload;
      const serviceArray = state.step2[serviceKey];
      if (!Array.isArray(serviceArray)) return;

      const index = serviceArray.findIndex((item) => item.id === id);

      if (index > -1) {
        if (value !== undefined) {
          serviceArray[index].value = value;
        } else {
          serviceArray.splice(index, 1);
        }
      } else {
        serviceArray.push({ id, value: value ?? 1 });
      }
    },

    toggleHotelService: (state, action) => {
      const { serviceKey, id } = action.payload;
      const serviceArray = state.step2[serviceKey];
      if (!Array.isArray(serviceArray)) return;

      const index = serviceArray.findIndex((item) => item.id === id);
      if (index > -1) {
        serviceArray.splice(index, 1);
      } else {
        serviceArray.push({ id, value: 1 });
      }
    },

    // ============================
    // Room Manipulation
    // ============================

    addRoom: (state, action) => {
      const newRoom = {
        room_type_id: null,
        room_option_id: null,
        bed_type_id: null,
        number_of_beds: 1,
        is_extra_beds_available: false,
        is_baby_beds_available: false,
        is_smoking_allowed: false,
        is_wheelchair_accessible: false,
        number_of_living_areas: 1,
        number_of_rooms: 1,
        total_rooms_of_this_type: 0,
        min_adults: 1,
        max_adults: 1,
        min_children: 0,
        max_children: 0,
        real_number_pax: 1,
        pricing: {
          start_date: "",
          end_date: "",
          price: "",
          mealId: null,
        },
        ...action.payload, // allow partial overrides
      };

      state.step3.rooms.push(newRoom);
    },
updateMealRates: (state, action) => {
  state.step3.meal_rate = action.payload;
},
    updateRoom: (state, action) => {
      const { index, data } = action.payload;
      if (state.step3.rooms[index]) {
        state.step3.rooms[index] = {
          ...state.step3.rooms[index],
          ...data,
        };
      }
    },

    updateRoomField: (state, action) => {
      const { index, field, value } = action.payload;
      if (!state.step3.rooms[index]) return;

      // Dot notation support for nested fields like "pricing.price"
      if (field.includes(".")) {
        const keys = field.split(".");
        let target = state.step3.rooms[index];
        for (let i = 0; i < keys.length - 1; i++) {
          if (!target[keys[i]]) return;
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
      } else {
        state.step3.rooms[index][field] = value;
      }
    },

    deleteRoom: (state, action) => {
      const { index } = action.payload;
      if (index >= 0 && index < state.step3.rooms.length) {
        state.step3.rooms.splice(index, 1);
      }
    },

    resetHotel: () => initialState,
  },
});

export const {
  updateHotelStepField,
  updateHotelStepBulk,
  setHotelProductId,
  resetHotel,
  updateHotelService,
  toggleHotelService,
  addRoom,
  updateMealRates,
  updateRoom,
  updateRoomField,
  deleteRoom,
} = hotelSlice.actions;

export default hotelSlice.reducer;
